var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.472 -431.729)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 497",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(18.472 431.729)",
    style: {
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 372",
    d: "M447.954 2017.636a1.637 1.637 0 0 0-1.036 2.906v1.405a1.036 1.036 0 0 0 2.072 0v-1.405a1.637 1.637 0 0 0-1.036-2.906zm.544 2.477-.145.094v1.74a.4.4 0 1 1-.8 0v-1.74l-.145-.094a1 1 0 1 1 1.088 0z",
    transform: "translate(-412.482 -1567.992)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39756",
    d: "M5.107 3.945A2.525 2.525 0 0 1 7.627 1.5h.081a2.525 2.525 0 0 1 2.44 2.439v3.055l-7.892.022A2.264 2.264 0 0 0 0 9.272v7.61a2.263 2.263 0 0 0 2.256 2.256H13a2.261 2.261 0 0 0 2.256-2.256V9.245A2.262 2.262 0 0 0 13 7h-1.324V3.944a4.019 4.019 0 0 0-1.244-2.835c-.087-.085-.189-.149-.283-.226l-.041-.031a4.059 4.059 0 0 0-.625-.4h-.011A3.944 3.944 0 0 0 8.76.165h-.021A3.991 3.991 0 0 0 7.99.029h-.049C7.837.029 7.736 0 7.632 0h-.086a4.038 4.038 0 0 0-3.964 3.964v.406h1.53zm8.624 12.918a.73.73 0 0 1-.213.517.715.715 0 0 1-.515.215H2.258a.733.733 0 0 1-.73-.729V9.252a.732.732 0 0 1 .73-.729H13a.731.731 0 0 1 .729.729z",
    transform: "translate(27.844 439.161)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.282ef7a95734f1601c4ec9b5d1766453.svg";
export { ForwardRef as ReactComponent };